import { Flex, Typography } from '@coolblue-development/freddy';
import { SelectableBox, SelectableBoxGroup } from '@coolblue-development/next-patterns/client';
import { SquareProductImage } from '@coolblue-development/next-patterns/client';
import { useContext } from 'react';

import { ProductTradeInContext } from '../../Context';
import { getImageId, mapOptionsToVariants } from '../../helpers';
import type { MappedOption } from '../../types';
import SelectorGrid from './SelectorGrid';

export const VariantSelector = ({
  options,
  level,
  selected,
  onSelect
}: {
  options?: MappedOption[];
  level: number;
  selected?: string | null;
  onSelect?: (optionId: string) => void;
}) => {
  const { options: allOptions, entry } = useContext(ProductTradeInContext);

  if (!options) return null;

  const variations = mapOptionsToVariants(options, level);

  return (
    <>
      <Typography variant='h3' mt={600} data-level={level}>
        {options[0]?.variances?.[level]?.title}
      </Typography>
      <SelectorGrid>
        <SelectableBoxGroup
          name={`variations_selector_group_level_${level}`}
          type='radio'
          spacing='default'
          inputPlacement='hidden'
          value={selected || ''}
          onChange={selection => onSelect?.(selection)}
        >
          {variations &&
            Object.entries(variations).map(([key, value]) => {
              const [firstVarianceLevel] = value;
              const imageId = getImageId({
                variance: firstVarianceLevel,
                options: allOptions,
                productImages: entry?.productImages
              });

              return (
                <SelectableBox value={key} key={key}>
                  <Flex
                    component='span'
                    direction='column'
                    justifyContent='center'
                    alignItems='center'
                    gap={200}
                  >
                    {imageId && (
                      <SquareProductImage
                        fileCollection='product'
                        alt={key}
                        imageId={String(imageId)}
                        size='large'
                        loading='eager'
                        background='transparent'
                      />
                    )}
                    <Typography component='span'>{key}</Typography>
                  </Flex>
                </SelectableBox>
              );
            })}
        </SelectableBoxGroup>
      </SelectorGrid>
    </>
  );
};
